import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

import FormikCheckboxField from "components/InputsField/formikInputs/FormikCheckboxField";
import FormikTextField from "components/InputsField/formikInputs/FormikTextField";
import { FreightsDropdowns } from "service/dropdownServices/FreightsDropdowns";
import AsyncSelect from "components/InputsField/formikInputs/AsyncSelect";
import CreatableAsyncSelect from "components/InputsField/formikInputs/CreatableAsyncSelect";
import { input50, input9999, onlyNumberInput } from "components/InputsField/inputFormats";
import Title from "components/common/Layout/Title";
import FormRow, { ALIGN } from "components/common/Layout/FormRow";

import styles from "./styles.module.scss";
import { UTILS } from "endpointsConst";

export default function FreightsParameters() {
    const [adrOptions, setAdrOptions] = useState([]);
    const { initialValues } = useFormikContext();
    const lang = useSelector((state) => state.settings.lang);
    const { t } = useTranslation();

    useEffect(() => {
        FreightsDropdowns.getAdr(lang)
            .then((res) => {
                let adrOptions = res.data.map((el) => {
                    return {
                        label: el.caption.title,
                        value: el.caption.id,
                    };
                });
                setAdrOptions(adrOptions);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, [lang]);

    return (
        <>
            <Title>{t("cargoFields.cargo_specification.heading")}</Title>
            <FormRow withMargin align={ALIGN.top}>
                <CreatableAsyncSelect
                    name="cargo_designations_id"
                    customFieldName="cargo_designations_additional"
                    label={t("cargoFields.cargo_specification.cargo_name")}
                    placeholder={initialValues.cargo_designation || ""}
                    url={`${UTILS}/cargoDesignations/?lang=${lang}`}
                    required
                    sort
                />
                <AsyncSelect
                    name="adr_captions_ids"
                    label={t("cargoFields.cargo_specification.adr")}
                    options={adrOptions}
                    placeholder=""
                    isMulti
                />
            </FormRow>

            <FormRow withMargin>
                <FormRow withSpace>
                    <FormikTextField
                        name="weight"
                        label={t("cargoFields.cargo_specification.weight")}
                        maxLength={6}
                        required
                        placeholder={t("cargoFields.cargo_specification.weight_grey")}
                        format={input9999}
                    />
                    <AsyncSelect
                        url={`${UTILS}/packages/?lang=${lang}`}
                        label={t("cargoFields.cargo_specification.package")}
                        name="packages_id"
                        isClearable={true}
                        sort
                    />
                </FormRow>
                <FormRow withSpace>
                    <FormikTextField
                        label={t("cargoFields.cargo_specification.piece")}
                        name="count"
                        maxLength={4}
                        placeholder=""
                        format={onlyNumberInput}
                    />
                    <FormikTextField
                        label={t("cargoFields.cargo_specification.straps")}
                        name="belts"
                        maxLength={4}
                        placeholder=""
                        format={onlyNumberInput}
                    />
                </FormRow>
            </FormRow>
            <FormRow withMargin align={ALIGN.top}>
                <div>
                    <FormRow withSpace>
                        <FormikTextField
                            label={t("cargoFields.cargo_specification.cubage")}
                            name="volume"
                            maxLength={6}
                            placeholder=""
                            format={input9999}
                        />
                        <FormRow withSpace>
                            <FormikTextField
                                label={t("cargoFields.cargo_specification.length")}
                                name="length"
                                maxLength={6}
                                placeholder=""
                                format={input50}
                            />
                            <FormikTextField
                                label={t("cargoFields.cargo_specification.width")}
                                name="width"
                                maxLength={6}
                                placeholder=""
                                format={input50}
                            />
                        </FormRow>
                    </FormRow>
                    <p className={styles.notes}>
                        {t("cargoFields.cargo_specification.weight_note")}
                    </p>
                </div>
                <FormRow align={ALIGN.top} withSpace>
                    <FormRow withSpace>
                        <FormikTextField
                            label={t("cargoFields.cargo_specification.height")}
                            name="height"
                            maxLength={4}
                            placeholder=""
                            format={input50}
                        />
                        <FormikTextField
                            label={t("cargoFields.cargo_specification.diameter")}
                            name="diameter"
                            maxLength={4}
                            placeholder=""
                            format={input50}
                        />
                    </FormRow>
                    <FormRow>
                        <div>
                            <AsyncSelect
                                url={`${UTILS}/transportation-types/?lang=${lang}`}
                                label={t("cargoFields.cargo_specification.loading")}
                                name="transportation_type_id"
                                isClearable={true}
                            />
                            <div className={styles.checkbox}>
                                <FormikCheckboxField
                                    name="modular_cargo"
                                    id="modular_cargo"
                                    label={t(
                                        "cargoFields.cargo_specification.consolidated_cargo_box",
                                    )}
                                />
                            </div>
                        </div>
                    </FormRow>
                </FormRow>
            </FormRow>
        </>
    );
}
